import "../css/errorPage.css";

export default function Error() {
    return (
        <h1 className="error-page"> There's nothing here... </h1>
    )
}